import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

import { __awaiter } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ConfirmationForm from '../ConfirmationForm';
import { RegistrationStatus } from '../../typings';
import { useLocale } from '../../i18n';
import PasswordForm from './PasswordForm';
import RegistrationForm from './RegistrationForm';
import Title from '../Core/Title';
var Step;

(function (Step) {
  Step[Step["Registration"] = 0] = "Registration";
  Step[Step["Password"] = 1] = "Password";
  Step[Step["Confirmation"] = 2] = "Confirmation";
})(Step || (Step = {}));

var Registration = function Registration(_ref) {
  var provider = _ref.provider,
      hintTooltip = _ref.hintTooltip,
      uiSettings = _ref.uiSettings,
      initialData = _ref.initialData,
      onCheckRegistration = _ref.onCheckRegistration,
      onRegister = _ref.onRegister,
      onConfirm = _ref.onConfirm,
      onWatch = _ref.onWatch,
      onResend = _ref.onResend,
      onLogin = _ref.onLogin,
      onClose = _ref.onClose;

  var _a;

  var _useLocale = useLocale(),
      i18n = _useLocale.i18n;

  var _useState = useState(Step.Registration),
      _useState2 = _slicedToArray(_useState, 2),
      step = _useState2[0],
      setStep = _useState2[1];

  var _useState3 = useState({
    email: (initialData === null || initialData === void 0 ? void 0 : initialData.email) || '',
    phone: (initialData === null || initialData === void 0 ? void 0 : initialData.phone) || ''
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      formValues = _useState4[0],
      setFormValues = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      confirmation = _useState6[0],
      setConfirmation = _useState6[1];

  var loginRef = useRef();
  var authIdRef = useRef();
  var handleLogin = useCallback(function (login, password) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return onLogin({
                provider: provider.id,
                login: login,
                password: password
              });

            case 3:
              res = _context.sent;
              onClose(res.confirmation);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              onClose();

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));
  }, [provider.id, onLogin, onClose]);
  var handleCheckRegistration = useCallback(function (values) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var userLogin;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return onCheckRegistration(values);

            case 2:
              userLogin = _context2.sent;
              setFormValues(values);
              loginRef.current = userLogin;
              onWatch && onWatch({
                status: RegistrationStatus.Entered,
                data: values
              });
              setStep(Step.Password);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  }, [onCheckRegistration, onWatch]);
  var handleRegister = useCallback(function (values) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
      var login, userData, res;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              login = loginRef.current;
              userData = Object.assign(Object.assign({}, initialData), {
                email: values.email,
                phone: values.phone,
                password: values.password
              });
              _context3.next = 4;
              return onRegister(userData);

            case 4:
              res = _context3.sent;
              setFormValues(values);
              onWatch && onWatch({
                status: RegistrationStatus.PasswordEntered,
                data: values
              });

              if (!res.confirmation.enable) {
                _context3.next = 13;
                break;
              }

              setConfirmation(res.confirmation);
              authIdRef.current = res.authId;
              setStep(Step.Confirmation);
              _context3.next = 16;
              break;

            case 13:
              onWatch && onWatch({
                status: RegistrationStatus.Completed,
                data: userData
              });
              _context3.next = 16;
              return handleLogin(login || '', values.password);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  }, [onRegister, initialData, handleLogin, onWatch]);
  var handleResend = useCallback(function () {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      var res;
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return onResend(authIdRef.current);

            case 2:
              res = _context4.sent;
              setConfirmation(res);

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  }, [onResend]);
  var handleConfirm = useCallback(function (code) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      var authId, login;
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              authId = authIdRef.current;
              login = loginRef.current;
              _context5.next = 4;
              return onConfirm(authId, code);

            case 4:
              onWatch && onWatch({
                status: RegistrationStatus.Completed,
                data: Object.assign(Object.assign(Object.assign({}, initialData), formValues), {
                  code: code
                })
              });
              _context5.next = 7;
              return handleLogin(login || '', formValues.password);

            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
  }, [onConfirm, handleLogin, onWatch, initialData, formValues]);
  var handleCancel = useCallback(function () {
    setStep(Step.Registration);
  }, []);
  var handleConfirmCancel = useCallback(function () {
    setStep(Step.Password);
  }, []);
  var codeCreated = useMemo(function () {
    return (confirmation === null || confirmation === void 0 ? void 0 : confirmation.enable) ? Date.now() : undefined;
  }, [confirmation]);
  useEffect(function () {
    onWatch && onWatch({
      status: RegistrationStatus.Init,
      data: initialData
    });
  }, [initialData, onWatch]);

  if (step === Step.Confirmation) {
    return _jsxs(_Fragment, {
      children: [!(uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.hideConfirmationTitle) && _jsx(Title, {
        text: (uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.confirmationTitle) || i18n('registration.title.confirm')
      }), _jsx(ConfirmationForm, Object.assign({}, confirmation, {
        codeCreated: codeCreated,
        hintTooltip: hintTooltip,
        onConfirm: handleConfirm,
        onResend: handleResend,
        onCancel: handleConfirmCancel
      }))]
    });
  }

  if (step === Step.Password) {
    return _jsxs(_Fragment, {
      children: [!(uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.hidePasswordTitle) && _jsx(Title, {
        text: (uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.passwordTitle) || i18n('registration.title.welcome')
      }), _jsx(PasswordForm, {
        data: formValues,
        hintTooltip: hintTooltip,
        onRegister: handleRegister,
        onCancel: handleCancel
      })]
    });
  }

  return _jsxs(_Fragment, {
    children: [!(uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.hideTitle) && _jsx(Title, {
      text: (uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.title) || i18n('registration.title.registration')
    }), _jsx(RegistrationForm, {
      data: formValues,
      hintTooltip: hintTooltip,
      autoFocus: (_a = uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.autoFocusFirstField) !== null && _a !== void 0 ? _a : true,
      submitButton: uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.submitButton,
      onRegister: handleCheckRegistration,
      onClose: (uiSettings === null || uiSettings === void 0 ? void 0 : uiSettings.hideFooter) ? undefined : onClose
    })]
  });
};

export default Registration;